// extracted by mini-css-extract-plugin
export default {"drawerContent":"drawerContent___YTJJw"};